// import { FC, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import { UploaderImage } from '../../../../../lib/components/UploadMultipleResolutionImages/UploaderImage';
// import { extract_num_id_from_id } from '../../utils/extract_num_id_from_id';

// interface IProps {
// 	src_img: string;
// }

// export const UploadImage: FC<IProps> = ({ src_img }) => {
// 	const [show_img, set_show_img] = useState(true);

// 	const { id: book_id, edition_id } = useParams() as { id: string; edition_id: string };

// 	const book_num_id = extract_num_id_from_id(book_id);
// 	const edition_num_id = extract_num_id_from_id(edition_id);

// 	const image_key = `books/cover/${book_num_id}/editions/${edition_num_id}.jpg`;

// 	return (
// 		<div className=' flex-col items-center justify-center text-center '>
// 			<div className='block'>
// 				{show_img && (
// 					<img
// 						{...{
// 							src: `${src_img}?d=${Date.now()}`,
// 							style: {
// 								maxHeight: 300,
// 							},
// 							alt: `${src_img}`,
// 						}}
// 						onError={(e: any) => {
// 							e.target.onerror = null;
// 							e.target.src = `${process.env.REACT_APP_PUBLIC_BUCKET_URL}/books/cover/default/no-image.png`;
// 						}}
// 					/>
// 				)}
// 			</div>

// 			<div className='mt-3'>
// 				<UploaderImage
// 					{...{
// 						upload_api_endpoint: `${process.env.REACT_APP_UPLOAD_IMAGE_API}`,
// 						image_key,
// 						on_success: () => {
// 							set_show_img(false);
// 							setTimeout(() => {
// 								try {
// 									set_show_img(true);
// 								} catch (error) {}
// 							}, 500);
// 						},
// 					}}
// 				/>
// 			</div>
// 		</div>
// 	);
// };
// import { FC, useState } from 'react';
// import { message } from 'antd';
// import { useParams } from 'react-router-dom';
// import { UploaderImage } from '../../../../../lib/components/UploadMultipleResolutionImages/UploaderImage';
// import { extract_num_id_from_id } from '../../utils/extract_num_id_from_id';

// interface IProps {
// 	src_img: string;
// }

// const MAX_FILE_SIZE_MB = 2;
// const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

// const ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

// const MIN_WIDTH = 800;
// const MIN_HEIGHT = 0;
// const MAX_WIDTH = 3200;
// const MAX_HEIGHT = 3200;

// const FILE_NAME_REGEX = /^[a-zA-Z0-9._-]+$/;

// function validateImageDimensions(file: File): Promise<boolean> {
// 	return new Promise((resolve) => {
// 		const reader = new FileReader();

// 		reader.onload = (event) => {
// 			const img = new Image();

// 			img.onload = () => {
// 				const { width, height } = img;

// 				const hasValidMinDimensions = width >= MIN_WIDTH && height >= MIN_HEIGHT;
// 				const hasValidMaxDimensions = width <= MAX_WIDTH && height <= MAX_HEIGHT;

// 				if (!hasValidMinDimensions || !hasValidMaxDimensions) {
// 					message.error(
// 						`A imagem deve ter no mínimo ${MIN_WIDTH}x${MIN_HEIGHT}px e no máximo ${MAX_WIDTH}x${MAX_HEIGHT}px.`
// 					);
// 					resolve(false);
// 					return;
// 				}

// 				resolve(true);
// 			};

// 			img.onerror = () => {
// 				message.error('Não foi possível validar as dimensões da imagem.');
// 				resolve(false);
// 			};

// 			img.src = event.target?.result as string;
// 		};

// 		reader.onerror = () => {
// 			message.error('Erro ao ler o arquivo da imagem.');
// 			resolve(false);
// 		};

// 		reader.readAsDataURL(file);
// 	});
// }

// async function validateCoverImage(file: File): Promise<boolean> {
// 	if (!ALLOWED_TYPES.includes(file.type)) {
// 		message.error('A imagem deve estar nos formatos JPG ou PNG.');
// 		return false;
// 	}

// 	if (file.size > MAX_FILE_SIZE_BYTES) {
// 		message.error(`A imagem deve ter no máximo ${MAX_FILE_SIZE_MB}MB.`);
// 		return false;
// 	}

// 	if (!FILE_NAME_REGEX.test(file.name)) {
// 		message.error(
// 			'O nome do arquivo não pode conter espaços ou caracteres especiais. Use apenas letras, números, hífen, underline e ponto.'
// 		);
// 		return false;
// 	}

// 	return await validateImageDimensions(file);
// }

// export const UploadImage: FC<IProps> = ({ src_img }) => {
// 	const [show_img, set_show_img] = useState(true);

// 	const { id: book_id, edition_id } = useParams() as { id: string; edition_id: string };

// 	const book_num_id = extract_num_id_from_id(book_id);
// 	const edition_num_id = extract_num_id_from_id(edition_id);

// 	const image_key = `books/cover/${book_num_id}/editions/${edition_num_id}.jpg`;

// 	return (
// 		<div className=' flex-col items-center justify-center text-center '>
// 			<div className='block'>
// 				{show_img && (
// 					<img
// 						{...{
// 							src: `${src_img}?d=${Date.now()}`,
// 							style: {
// 								maxHeight: 300,
// 							},
// 							alt: `${src_img}`,
// 						}}
// 						onError={(e: any) => {
// 							e.target.onerror = null;
// 							e.target.src = `${process.env.REACT_APP_PUBLIC_BUCKET_URL}/books/cover/default/no-image.png`;
// 						}}
// 					/>
// 				)}
// 			</div>

// 			<div className='mt-3'>
// 				<UploaderImage
// 					{...{
// 						upload_api_endpoint: `${process.env.REACT_APP_UPLOAD_IMAGE_API}`,
// 						image_key,
// 						before_upload: validateCoverImage,
// 						on_success: () => {
// 							set_show_img(false);
// 							setTimeout(() => {
// 								try {
// 									set_show_img(true);
// 								} catch (error) {}
// 							}, 500);
// 						},
// 					}}
// 				/>
// 			</div>
// 		</div>
// 	);
// };
import { FC, useState } from 'react';
import { message } from 'antd';
import { useParams } from 'react-router-dom';
import { UploaderImage } from '../../../../../lib/components/UploadMultipleResolutionImages/UploaderImage';
import { extract_num_id_from_id } from '../../utils/extract_num_id_from_id';

interface IProps {
	src_img: string;
}

const MAX_FILE_SIZE_MB = 2;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

const ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

const MIN_HEIGHT = 800;
const MAX_WIDTH = 3200;
const MAX_HEIGHT = 3200;

const FILE_NAME_REGEX = /^[a-zA-Z0-9._-]+$/;

function validateImageDimensions(file: File): Promise<boolean> {
	return new Promise((resolve) => {
		const reader = new FileReader();

		reader.onload = (event) => {
			const img = new Image();

			img.onload = () => {
				const { width, height } = img;

				const hasValidHeight = height >= MIN_HEIGHT;
				const hasValidMaxDimensions = width <= MAX_WIDTH && height <= MAX_HEIGHT;

				if (!hasValidHeight || !hasValidMaxDimensions) {
					message.error(
						`A imagem deve ter altura mínima de ${MIN_HEIGHT}px e no máximo ${MAX_WIDTH}x${MAX_HEIGHT}px.`
					);
					resolve(false);
					return;
				}

				resolve(true);
			};

			img.onerror = () => {
				message.error('Não foi possível validar as dimensões da imagem.');
				resolve(false);
			};

			img.src = event.target?.result as string;
		};

		reader.onerror = () => {
			message.error('Erro ao ler o arquivo da imagem.');
			resolve(false);
		};

		reader.readAsDataURL(file);
	});
}

async function validateCoverImage(file: File): Promise<boolean> {
	if (!ALLOWED_TYPES.includes(file.type)) {
		message.error('A imagem deve estar nos formatos JPG ou PNG.');
		return false;
	}

	if (file.size > MAX_FILE_SIZE_BYTES) {
		message.error(`A imagem deve ter no máximo ${MAX_FILE_SIZE_MB}MB.`);
		return false;
	}

	if (!FILE_NAME_REGEX.test(file.name)) {
		message.error(
			'O nome do arquivo não pode conter espaços ou caracteres especiais. Use apenas letras, números, hífen, underline e ponto.'
		);
		return false;
	}

	return await validateImageDimensions(file);
}

export const UploadImage: FC<IProps> = ({ src_img }) => {
	const [show_img, set_show_img] = useState(true);

	const { id: book_id, edition_id } = useParams() as { id: string; edition_id: string };

	const book_num_id = extract_num_id_from_id(book_id);
	const edition_num_id = extract_num_id_from_id(edition_id);

	const image_key = `books/cover/${book_num_id}/editions/${edition_num_id}.jpg`;

	return (
		<div className='flex-col items-center justify-center text-center'>
			<div className='block'>
				{show_img && (
					<img
						{...{
							src: `${src_img}?d=${Date.now()}`,
							style: {
								maxHeight: 300,
							},
							alt: `${src_img}`,
						}}
						onError={(e: any) => {
							e.target.onerror = null;
							e.target.src = `${process.env.REACT_APP_PUBLIC_BUCKET_URL}/books/cover/default/no-image.png`;
						}}
					/>
				)}
			</div>

			<div className='mt-3'>
				<UploaderImage
					{...{
						upload_api_endpoint: `${process.env.REACT_APP_UPLOAD_IMAGE_API}`,
						image_key,
						before_upload: validateCoverImage,
						on_success: () => {
							set_show_img(false);
							setTimeout(() => {
								try {
									set_show_img(true);
								} catch (error) {}
							}, 500);
						},
					}}
				/>
			</div>
		</div>
	);
};
